import { render, staticRenderFns } from "./state-abbrs-card.vue?vue&type=template&id=5ebb5886"
import script from "./state-abbrs-card.vue?vue&type=script&lang=js"
export * from "./state-abbrs-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports